import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BenefitsResolver } from '@benefits/benefits.resolver';

/* Common Modules */
import { BenefitsRouterModule } from '@benefits/benefits.routes';

/* Module Views */
import { AppCommonModule } from '@common/common.module';

import { TableModule } from '@app/modules/table/table.module';
import { PlatformModule } from '@app/platform.module';
import {
    BenefitDetailsSimplyBenefits,
    BenefitDetailsStandard,
    BenefitInvoiceUnmappedEmployeesComponent,
    BenefitsChangeRequestBanner,
    Components,
} from '@benefits/components';
import { Services } from '@benefits/services';
import { ChangeRequestIndexTable } from '@benefits/services/tables/change-request-table/change-request-index.table';
import { PlansIndexTable } from '@benefits/services/tables/plans-table/plans-index.table';
import { Views } from '@benefits/views';
import { EmployeeFormsModule } from '@forms/employees/employee-forms.module';
import { PayrollFormsModule } from '@forms/payroll/payroll-forms.module';
import { BenefitTypeResolver, PayrollPendingStateResolver } from '@payroll/resolvers';
import { BenefitsFormsModule } from '../forms/benefits/benefits-forms.module';
import { PayrollModule } from '../payroll/payroll.module';
import { BenefitInvoicesTable } from '@benefits/services/tables/benefit-invoices-table/benefit-invoices.table';

@NgModule({
    imports: [
        BenefitsRouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppCommonModule,
        PlatformModule,
        TableModule,
        BenefitsFormsModule,
        EmployeeFormsModule,
        PayrollFormsModule,
        PayrollModule,
        BenefitInvoiceUnmappedEmployeesComponent,
    ],
    declarations: [...Views, ...Components],
    providers: [
        ...Services,
        BenefitsResolver,
        PlansIndexTable,
        ChangeRequestIndexTable,
        PayrollPendingStateResolver,
        BenefitTypeResolver,
        BenefitInvoicesTable,
    ],
    exports: [BenefitsChangeRequestBanner, BenefitDetailsStandard, BenefitDetailsSimplyBenefits],
})
export class BenefitsModule {}
